import moment from 'moment';
import Cookies from 'universal-cookie';

const postPresenceClockInPayload = (formData) => {
  const cookies = new Cookies();
  const timezone = cookies.get('organization')?.timezone;
  
  return {
    startedAt: moment.tz(timezone).format('YYYY-MM-DD HH:mm:ss'),
    deviceId: formData?.deviceId,
  };
};

export default postPresenceClockInPayload;
